/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DocumentType } from './';
import {
    DocumentTypeFromJSON,
    DocumentTypeFromJSONTyped,
    DocumentTypeToJSON,
} from './';
import type { UsageType } from './';
import {
    UsageTypeFromJSON,
    UsageTypeFromJSONTyped,
    UsageTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceFileType
 */
export interface ComplianceFileType {
    /**
     * 
     * @type {string}
     * @memberof ComplianceFileType
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceFileType
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceFileType
     */
    infos?: string;
    /**
     * 
     * @type {number}
     * @memberof ComplianceFileType
     */
    daysValidity?: number;
    /**
     * 
     * @type {DocumentType}
     * @memberof ComplianceFileType
     */
    type: DocumentType;
    /**
     * 
     * @type {UsageType}
     * @memberof ComplianceFileType
     */
    usageType: UsageType;
}

/**
 * Check if a given object implements the ComplianceFileType interface.
 */
export function instanceOfComplianceFileType(value: object): value is ComplianceFileType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('usageType' in value) || value['usageType'] === undefined) return false;
    return true;
}

export function ComplianceFileTypeFromJSON(json: any): ComplianceFileType {
    return ComplianceFileTypeFromJSONTyped(json, false);
}

export function ComplianceFileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceFileType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'infos': json['infos'] == null ? undefined : json['infos'],
        'daysValidity': json['daysValidity'] == null ? undefined : json['daysValidity'],
        'type': DocumentTypeFromJSON(json['type']),
        'usageType': UsageTypeFromJSON(json['usageType']),
    };
}

export function ComplianceFileTypeToJSON(value?: ComplianceFileType | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
        'infos': value['infos'],
        'daysValidity': value['daysValidity'],
        'type': DocumentTypeToJSON(value['type']),
        'usageType': UsageTypeToJSON(value['usageType']),
    };
}

